/**
 * Global Section Animations
 * Automatically applies fade-in animations to all sections on scroll
 */

class SectionAnimations {
  constructor() {
    this.sections = document.querySelectorAll('.section, .slideshow-section, .product-grid-container');
    this.observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };
    
    this.init();
  }

  init() {
    // Add animation class to all sections
    this.sections.forEach(section => {
      // Skip if section already has animation or is in header/footer
      if (section.closest('header') || section.closest('footer')) {
        return;
      }
      
      section.classList.add('section-animate');
    });

    // Set up Intersection Observer
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('section-animate--visible');
          // Optionally unobserve after animation
          this.observer.unobserve(entry.target);
        }
      });
    }, this.observerOptions);

    // Observe all sections
    this.sections.forEach(section => {
      if (!section.closest('header') && !section.closest('footer')) {
        this.observer.observe(section);
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new SectionAnimations();
  });
} else {
  new SectionAnimations();
}
